module.exports = __webpack_public_path__ + "img/logo.b093b14e.png";